<template>
  <v-layout fill-height column>
    <div class="solution-finish">
      <div class="solution-finish-text" v-html="finishSay"></div>
    </div>
    <v-footer app fixed grow color="white" class="content-footer">
      <v-container v-if="isRealtalkReqUse && $store.state.client.contract.allowsRealtalkService" fluid class="pb-0">
        <v-checkbox
            v-model="checkbox"
            :label="label"
            :ripple="false"
            :readonly="cmplt"
            hide-details
            class="checkbox-circle"
        ></v-checkbox>
      </v-container>
      <FooterBtns v-if="!popup" :ok="'완료'" @submit="finish"/>
      <FooterBtns v-else :ok="'완료'" @submit="$emit('popupFinish')"/>
    </v-footer>
  </v-layout>
</template>
<script>
import {mixinReward} from '@/mixins'
import FooterBtns from '@/components/btns/FooterBtns'

export default {
  components: {
    FooterBtns
  },
  mixins: [mixinReward],
  props: ['finishSay', 'cmpltYn', 'popupYn', 'dailyUnitYn', 'realtalkReqUseYn', 'realtalkReqYn', 'isMindNote', 'isMindWeather', 'pastYn'],
  data: () => ({
    checkbox: false,
    description: '',
    label: '이 주제로 가이드의 피드백을 받고 싶어요.',
    cmplt: false,
    popup: false,
    isRealtalkReqUse: true
  }),
  created () {
    this.cmplt = (this.cmpltYn === 'true' || this.cmpltYn === true)
    this.popup = this.popupYn
    this.isRealtalkReqUse = this.realtalkReqUseYn === 'Y'
    this.checkbox = this.realtalkReqYn === 'Y'
  },
  methods: {
    finish() {
      if (this.isMindWeather && !this.cmplt) {
        this.insertMemberBadgePoss(7, 4)
        // this.$root.$children[0].$refs.content.$emit('insertMemberBadgePoss', 7,4)
      } else if (this.isMindNote && !this.cmplt) {
        this.insertMemberBadgePoss(8, 4)
        // this.$root.$children[0].$refs.content.$emit('insertMemberBadgePoss', 8,4)
      }

      // 데일리유닛, 과거유닛 제외 유닛완료 코인획득
      if (this.dailyUnitYn !== 'Y' && this.pastYn !== 'Y' && !this.cmplt) {
        this.insertMemberCoin(this.$store.state.auth.authUser.userKey, 1, '0006')
        // this.$root.$children[0].$refs.content.$emit('insertMemberCoin',this.$store.state.auth.authUser.userKey, 1, '0006')
      }
      this.$emit('finish', this.checkbox)
    }
  }
}
</script>
